module.exports = __webpack_public_path__ + "media/images/admin/icons/wifi-d78a04932be0a690e8147593976054d0.svg";